import { writable } from 'svelte/store';

export const user = writable(false);